import React from "react";
import tw, { css } from "twin.macro";

// ========= UTILS =========
import { BUTTON_RADIUS, COLORS, ENUMS } from "../../libs/globals";

// ========= ICONS =========
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleDown as dropdownIcon } from "@fortawesome/free-solid-svg-icons";

// ========= COMPONENTS =========
import Select, { components } from "react-select";

// ========= MAIN =========
const Dropdown = ({
	options = [],
	color = ENUMS.COLORS.AFTER,
	setState,
}) => {
	// ========= REACT-SELECT OVERRIDES =========
	// the main pill-shape
	const Control = (props) => (
		<components.Control
			{...props}
			css={[
				tw`
					rounded-button border-none
					text-xl pl-3
					flex items-center
					shadow-none
				`,
				COLORS[color].dropdownBody,
			]}
		/>
	);

	// the icon on the right
	const DropdownIndicator = () => {
		return (
			<div tw="px-2 leading-none z-20">
				<span
					tw="flex items-center justify-center"
					className="fa-layers fa-fw "
				>
					<FontAwesomeIcon
						icon={dropdownIcon}
						css={COLORS[color].dropdownIcon}
					/>
				</span>
			</div>
		);
	};

	// the container for all the options
	const Menu = ({ children, ...props }) => (
		<components.Menu
			{...props}
			css={[
				tw`
				m-0  
				overflow-hidden shadow-none z-0 
				font-bold leading-snug
				`,
				COLORS[color].dropdownBody,
				css`
					padding-top: ${BUTTON_RADIUS}px;
					margin-top: -${BUTTON_RADIUS}px;

					position: relative;

					border-radius: 0 0 ${BUTTON_RADIUS}px
						${BUTTON_RADIUS}px;
				`,
			]}
		>
			{children}
		</components.Menu>
	);

	// the selected value
	const SingleValue = ({ children, ...props }) => (
		<components.SingleValue
			{...props}
			css={[
				tw`z-50 font-bold`,
				COLORS[color].dropdownSelectedOption,
			]}
		>
			{children}
		</components.SingleValue>
	);

	// the options
	const optionStyles = (styles) => {
		return Object.assign(
			styles,
			tw`text-lg px-5 z-50`,
			COLORS[color].dropdownOptions
		);
	};

	// ========= MAIN RETURN =========
	return (
		<Select
			options={options.map((option) => ({
				value: option.answer || option,
				label: option.answer || option,
			}))}
			onChange={(value) => setState(value)}
			isSearchable={false}
			autoFocus
			placeholder={false}
			components={{
				DropdownIndicator,
				Control,
				IndicatorSeparator: () => <></>,
				Menu,
				SingleValue,
			}}
			styles={{
				option: optionStyles,
			}}
		/>
	);
};

export default Dropdown;
